import Vue from 'vue'

const contextPotModule = {
    namespaced: true,
    
    state: {
        items: [],
        lastUpdated: null
    },
    
    getters: {
        allItems: state => state.items,
        itemCount: state => state.items.length,
        isEmpty: state => state.items.length === 0,
        hasItem: state => item => {
            return state.items.some(potItem => 
                JSON.stringify(potItem) === JSON.stringify(item)
            )
        },
        findItemById: state => id => {
            return state.items.find(item =>
                (item._id?.$oid || item._id?.$id || item.id) === id
            )
        }
    },
    
    mutations: {
        ADD_ITEM(state, item) {
            // Check if item already exists
            const exists = state.items.some(potItem => 
                JSON.stringify(potItem) === JSON.stringify(item)
            )
            
            if (!exists) {
                state.items.push(item)
                state.lastUpdated = new Date().toISOString()
            }
        },
        
        REMOVE_ITEM(state, index) {
            if (index >= 0 && index < state.items.length) {
                state.items.splice(index, 1)
                state.lastUpdated = new Date().toISOString()
            }
        },
        
        REMOVE_ITEM_BY_ID(state, id) {
            const index = state.items.findIndex(item =>
                (item._id?.$oid || item._id?.$id || item.id) === id
            )
            if (index !== -1) {
                state.items.splice(index, 1)
                state.lastUpdated = new Date().toISOString()
            }
        },
        
        CLEAR_ALL(state) {
            state.items = []
            state.lastUpdated = new Date().toISOString()
        },
        
        SET_ITEMS(state, items) {
            state.items = items
            state.lastUpdated = new Date().toISOString()
        },
        
        TOGGLE_ITEM(state, item) {
            const existingIndex = state.items.findIndex(potItem => {
                // Check by ID first
                if ((item._id?.$oid || item._id?.$id || item.id) && (potItem._id?.$oid || potItem._id?.$id || potItem.id)) {
                    return (item._id?.$oid || item._id?.$id || item.id) === (potItem._id?.$oid || potItem._id?.$id || potItem.id)
                }
                // Fallback to JSON comparison
                return JSON.stringify(potItem) === JSON.stringify(item)
            })
            
            if (existingIndex !== -1) {
                state.items.splice(existingIndex, 1)
            } else {
                state.items.push(item)
            }
            state.lastUpdated = new Date().toISOString()
        }
    },
    
    actions: {
        addItem({ commit, state }, item) {
            return new Promise((resolve, reject) => {
                const exists = state.items.some(potItem => 
                    JSON.stringify(potItem) === JSON.stringify(item)
                )
                
                if (!exists) {
                    commit('ADD_ITEM', item)
                    resolve({ success: true, message: 'Added to context pot' })
                } else {
                    resolve({ success: false, message: 'Item already in context pot' })
                }
            })
        },
        
        removeItem({ commit }, index) {
            commit('REMOVE_ITEM', index)
            return Promise.resolve({ success: true, message: 'Removed from context pot' })
        },
        
        removeItemById({ commit }, id) {
            commit('REMOVE_ITEM_BY_ID', id)
            return Promise.resolve({ success: true, message: 'Removed from context pot' })
        },
        
        clearAll({ commit }) {
            commit('CLEAR_ALL')
            return Promise.resolve({ success: true, message: 'Context pot cleared' })
        },
        
        toggleItem({ commit, state }, item) {
            const exists = state.items.some(potItem => {
                // Check by ID first
                if ((item._id?.$oid || item._id?.$id || item.id) && (potItem._id?.$oid || potItem._id?.$id || potItem.id)) {
                    return (item._id?.$oid || item._id?.$id || item.id) === (potItem._id?.$oid || potItem._id?.$id || potItem.id)
                }
                // Fallback to JSON comparison
                return JSON.stringify(potItem) === JSON.stringify(item)
            })
            
            commit('TOGGLE_ITEM', item)
            
            if (exists) {
                return Promise.resolve({ success: true, message: 'Removed from context pot', action: 'removed' })
            } else {
                return Promise.resolve({ success: true, message: 'Added to context pot', action: 'added' })
            }
        },
        
        syncItems({ commit }, items) {
            commit('SET_ITEMS', items)
            return Promise.resolve({ success: true, message: 'Context pot synced' })
        }
    }
}

export default contextPotModule